import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./Home.css";
import api from '../../../services/api';
import { Grid, TextField } from '@mui/material';
import API_CONFIG from '../../../config/api.config';

// Dados de exemplo das solicitações das prefeituras
/*const solicitacoesExemplo = [
  {
    SOL_ID: 1,
    PRE_NOME: "Prefeitura de São Paulo",
    VEI_DESCRICAO: "Caminhão Mercedes-Benz",
    VEI_PLACA: "ABC-1234",
    SOL_DATA_VINCULACAO: "2024-03-20 10:30:00",
    VEI_TIPO: "Caminhão"
  },
  {
    SOL_ID: 2,
    PRE_NOME: "Prefeitura de Campinas",
    VEI_DESCRICAO: "Van Fiat Ducato",
    VEI_PLACA: "DEF-5678",
    SOL_DATA_VINCULACAO: "2024-03-19 15:45:00",
    VEI_TIPO: "Van"
  },
  {
    SOL_ID: 3,
    PRE_NOME: "Prefeitura de Santos",
    VEI_DESCRICAO: "Ônibus Mercedes-Benz",
    VEI_PLACA: "GHI-9012",
    SOL_DATA_VINCULACAO: "2024-03-18 09:15:00",
    VEI_TIPO: "Ônibus"
  },
  {
    SOL_ID: 4,
    PRE_NOME: "Prefeitura de Ribeirão Preto",
    VEI_DESCRICAO: "Caminhão Volvo",
    VEI_PLACA: "JKL-3456",
    SOL_DATA_VINCULACAO: "2024-03-17 14:20:00",
    VEI_TIPO: "Caminhão"
  },
  {
    SOL_ID: 5,
    PRE_NOME: "Prefeitura de São José dos Campos",
    VEI_DESCRICAO: "Van Volkswagen",
    VEI_PLACA: "MNO-7890",
    SOL_DATA_VINCULACAO: "2024-03-16 11:20:00",
    VEI_TIPO: "Van"
  },
  {
    SOL_ID: 6,
    PRE_NOME: "Prefeitura de Sorocaba",
    VEI_DESCRICAO: "Ônibus Scania",
    VEI_PLACA: "PQR-1234",
    SOL_DATA_VINCULACAO: "2024-03-15 16:30:00",
    VEI_TIPO: "Ônibus"
  },
  {
    SOL_ID: 7,
    PRE_NOME: "Prefeitura de São Bernardo",
    VEI_DESCRICAO: "Caminhão Iveco",
    VEI_PLACA: "STU-5678",
    SOL_DATA_VINCULACAO: "2024-03-14 09:45:00",
    VEI_TIPO: "Caminhão"
  },
  {
    SOL_ID: 8,
    PRE_NOME: "Prefeitura de Guarulhos",
    VEI_DESCRICAO: "Van Renault",
    VEI_PLACA: "VWX-9012",
    SOL_DATA_VINCULACAO: "2024-03-13 13:15:00",
    VEI_TIPO: "Van"
  }
];*/ // Remover dados de exemplo

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Sempre pega do localStorage
  const fornecedorId = localStorage.getItem('idFornecedor');
  //console.log('ID do Fornecedor:', fornecedorId);

  useEffect(() => {
    const tipoUsuario = localStorage.getItem('tipoUsuario');
    if (tipoUsuario !== 'FORNECEDOR') {
      navigate('/');
    }
  }, [navigate]);

  const [isFornecedorMenuExpanded, setIsFornecedorMenuExpanded] = useState(false);
  const [fornecedorSearchTerm, setFornecedorSearchTerm] = useState('');
  const [fornecedorDataInicio, setFornecedorDataInicio] = useState('');
  const [fornecedorDataFim, setFornecedorDataFim] = useState('');
  const [fornecedorCurrentPage, setFornecedorCurrentPage] = useState(1);
  //const [fornecedorSolicitacoes, setFornecedorSolicitacoes] = useState(solicitacoesExemplo); // Remover estado de solicitacoes com dados de exemplo
  const [fornecedorSolicitacoesFiltradas, setFornecedorSolicitacoesFiltradas] = useState([]); // Começa vazio
  const [fornecedorLoading, setFornecedorLoading] = useState(false); // Estado de loading
  const [fornecedorPaginacao, setFornecedorPaginacao] = useState(null); // Estado para dados de paginação da API

  // Função para limitar o tamanho do texto
  const fornecedorLimitarTexto = (texto, limite = 50) => {
    if (texto.length <= limite) return texto;
    return texto.substring(0, limite) + '...';
  };

  // Função para extrair o ID da solicitação do termo de busca
  const fornecedorExtrairIdSolicitacao = (termo) => {
    const id = termo.replace(/[^\d]/g, '');
    return id ? parseInt(id) : null;
  };

  // Função para formatar a data para comparação
  const fornecedorFormatarDataParaComparacao = (dataString) => {
    const dataSemHora = dataString.split(' ')[0];
    return new Date(dataSemHora);
  };

  // Buscar solicitações enviadas para o fornecedor via API
  const buscarSolicitacoesFornecedor = async () => {
    if (!fornecedorId) {
      //console.log('ID do fornecedor não encontrado');
      return;
    }
    try {
      setFornecedorLoading(true);
      //console.log('Buscando solicitações para o fornecedor:', fornecedorId);
      
      const params = {
        page: fornecedorCurrentPage,
        per_page: 8
      };

      const url = API_CONFIG.ENDPOINTS.SOLICITACOES.FORNECEDOR(fornecedorId);
      //console.log('URL da API:', url);
      //console.log('Parâmetros:', params);

      const response = await api.get(url, { params });
      //console.log('Resposta da API:', response.data);

      const data = response.data;

      if (data && data.status && data.solicitacoes) {
        //console.log('Dados de paginação recebidos:', data.solicitacoes);
        setFornecedorPaginacao(data.solicitacoes);
      } else {
        //console.log('Dados inválidos recebidos da API:', data);
        setFornecedorPaginacao(null);
      }
    } catch (error) {
      //console.error('Erro ao buscar solicitações:', error);
      //console.error('Detalhes do erro:', error.response?.data);
      setFornecedorPaginacao(null);
    } finally {
      setFornecedorLoading(false);
    }
  };

  // Função para filtrar as solicitações (agora filtra sobre os dados da API)
  const fornecedorFiltrarSolicitacoes = () => {
    //console.log('Iniciando filtragem com dados:', fornecedorPaginacao?.data);
    // Filtra sobre os dados da PÁGINA ATUAL retornada pela API
    let resultado = fornecedorPaginacao?.data ? [...fornecedorPaginacao.data] : [];
    //console.log('Dados antes da filtragem:', resultado);

    // Filtro por ID (mantido no frontend, pois a API não suporta busca por ID no endpoint de lista)
    if (fornecedorSearchTerm) {
      const idSolicitacao = fornecedorExtrairIdSolicitacao(fornecedorSearchTerm);
      if (idSolicitacao !== null) {
        resultado = resultado.filter(solicitacao =>
          solicitacao.SOL_ID === idSolicitacao
        );
      } else if (fornecedorSearchTerm.trim() !== '') { // Se houver texto mas não for um ID válido
        resultado = []; // Não mostra nada se a busca não for um número válido
      }
    }

    // Filtro por data (mantido no frontend, aplicado aos dados da página atual)
    if (fornecedorDataInicio) {
      const inicio = new Date(fornecedorDataInicio);
      resultado = resultado.filter(solicitacao => {
        const dataSolicitacao = fornecedorFormatarDataParaComparacao(solicitacao.SOL_DATA_VINCULACAO);
        return dataSolicitacao >= inicio;
      });
    }

    if (fornecedorDataFim) {
      const fim = new Date(fornecedorDataFim);
      fim.setHours(23, 59, 59, 999); // Ajusta para o final do dia
      resultado = resultado.filter(solicitacao => {
        const dataSolicitacao = fornecedorFormatarDataParaComparacao(solicitacao.SOL_DATA_VINCULACAO);
        return dataSolicitacao <= fim;
      });
    }

    setFornecedorSolicitacoesFiltradas(resultado);
    // Não reseta a página aqui, pois a paginação é controlada pela API
  };

  // Efeito para buscar dados da API ao montar ou mudar página/filtros de data
  useEffect(() => {
    buscarSolicitacoesFornecedor();
  }, [fornecedorId, fornecedorCurrentPage]); // Depende do ID do fornecedor e da página atual

  // Efeito para aplicar o filtro por searchTerm e data quando os dados da API ou os filtros locais mudarem
  useEffect(() => {
    fornecedorFiltrarSolicitacoes();
  }, [fornecedorSearchTerm, fornecedorDataInicio, fornecedorDataFim, fornecedorPaginacao]); // Depende dos filtros locais e dos dados da API

  // Funções de navegação (usando URLs da paginação da API se disponíveis)
  const fornecedorNextPage = () => {
    if (fornecedorPaginacao?.next_page_url) {
      const url = new URL(fornecedorPaginacao.next_page_url);
      const page = url.searchParams.get('page');
      setFornecedorCurrentPage(Number(page));
    }
  };

  const fornecedorPrevPage = () => {
    if (fornecedorPaginacao?.prev_page_url) {
      const url = new URL(fornecedorPaginacao.prev_page_url);
      const page = url.searchParams.get('page');
      setFornecedorCurrentPage(Number(page));
    }
  };

  // Monitora mudanças no menu através de um evento personalizado
  useEffect(() => {
    const handleFornecedorMenuChange = (event) => {
      setIsFornecedorMenuExpanded(!event.detail.isCollapsed);
    };

    window.addEventListener('menuStateChange', handleFornecedorMenuChange);
    return () => window.removeEventListener('menuStateChange', handleFornecedorMenuChange);
  }, []);

  const handleFornecedorViewSolicitacao = (solicitacao) => {
    navigate(`/fornecedor/inserir-cotacao/${solicitacao.SOL_ID}`, { state: { solicitacao } });
  };

  //console.log('Solicitações filtradas:', fornecedorSolicitacoesFiltradas);
  //console.log('Itens atuais:', fornecedorSolicitacoesFiltradas);

  return (
    <div className={`fornecedor-home-container ${isFornecedorMenuExpanded ? 'menu-expanded' : ''}`}>
      {/* Central Modal */}
      <div className="fornecedor-modal-wrapper">
        <h1 className="fornecedor-modal-title">Consultar Solicitações</h1>
        <div className="fornecedor-modal-content">
          <div className="fornecedor-search-container" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <input
              type="text"
              placeholder="Digite o Nº da solicitação (ex: 2)"
              value={fornecedorSearchTerm}
              onChange={(e) => setFornecedorSearchTerm(e.target.value)}
              className="fornecedor-search-input"
              style={{ minWidth: 180, maxWidth: 220, width: 180 }}
            />
            <TextField
              label="Data Início"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={fornecedorDataInicio}
              onChange={(e) => setFornecedorDataInicio(e.target.value)}
              inputProps={{ max: fornecedorDataFim }}
              style={{ minWidth: 150 }}
            />
            <TextField
              label="Data Fim"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={fornecedorDataFim}
              onChange={(e) => setFornecedorDataFim(e.target.value)}
              inputProps={{ min: fornecedorDataInicio }}
              style={{ minWidth: 150 }}
            />
            <button
              className="fornecedor-search-button"
              onClick={fornecedorFiltrarSolicitacoes} // Botão dispara o filtro local
              style={{ height: 40, marginLeft: 4 }}
            >
              PROCURAR
            </button>
          </div>

          <div className="fornecedor-cards-grid">
            {fornecedorLoading ? (
              <div className="fornecedor-loading">
                Carregando solicitações...
              </div>
            ) : fornecedorSolicitacoesFiltradas && fornecedorSolicitacoesFiltradas.length > 0 ? ( // Renderiza a partir dos itens filtrados localmente
              fornecedorSolicitacoesFiltradas.map((solicitacao) => (
                <div key={solicitacao.SOL_ID} className="fornecedor-card">
                  <h2 className="fornecedor-card-title">Solicitação #{solicitacao.SOL_ID}</h2>
                  <div className="fornecedor-card-content">
                    <div className="fornecedor-card-info">
                     
                      <strong> {solicitacao.PRE_NOME || 'Não informado'}</strong>
                    </div>
                    <br></br>
                    <div className="fornecedor-card-info">
                      <strong>Veículo:</strong> {solicitacao.VEI_DESCRICAO} ({solicitacao.VEI_PLACA})
                    </div>
                    <div className="fornecedor-card-info">
                      <strong>Data de abertura:</strong> {new Date(solicitacao.SOL_DATA_VINCULACAO).toLocaleDateString('pt-BR')}
                    </div>
                    <div className="fornecedor-card-info">
                      <strong>Tipo:</strong> {solicitacao.VEI_TIPO}
                    </div>
                    <div className="fornecedor-card-info">
                      <strong>Quantidade de itens:</strong> {solicitacao.quantidade_itens}
                    </div>
                    <button
                      className="fornecedor-ver-cotacao-btn"
                      onClick={() => handleFornecedorViewSolicitacao(solicitacao)}
                    >
                      Ver Itens
                    </button>
                  </div>
                </div>
              ))
            ) : ( fornecedorPaginacao?.data && fornecedorPaginacao.data.length > 0 && (fornecedorSearchTerm || fornecedorDataInicio || fornecedorDataFim) ) ? (
                 // Se houver dados da API, mas nenhum resultado após o filtro local
                 <div className="fornecedor-no-results">
                   Nenhuma solicitação encontrada com os filtros aplicados nesta página.
                 </div>
            ) : (
              <div className="fornecedor-no-results">
                Nenhuma solicitação encontrada.
              </div>
            )}
          </div>

          <div className="fornecedor-pagination">
            {fornecedorPaginacao && (
              <>
                {/* Usar os links da API para navegação */}
                {fornecedorPaginacao.prev_page_url && (
                  <button className="fornecedor-pagination-btn" onClick={fornecedorPrevPage} disabled={fornecedorLoading}>
                    Voltar
                  </button>
                )}

                <span className="fornecedor-pagination-info">
                  Página {fornecedorPaginacao.current_page} de {fornecedorPaginacao.last_page}
                </span>
                {fornecedorPaginacao.next_page_url && (
                  <button className="fornecedor-pagination-btn" onClick={fornecedorNextPage} disabled={fornecedorLoading}>
                    Próximo
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;